import {
  TAbstractEntity,
  TAbstractNewEntity,
  TEditorConfig,
} from './Editor/interface';
import { default as Wrapper } from './Wrapper';
import { genEditorContext } from './context';

export function createEditor<
  TContainer extends TAbstractEntity | null,
  TEntity extends TAbstractEntity,
  TNewEntity extends TAbstractNewEntity,
>(config: TEditorConfig<TContainer, TEntity, TNewEntity>) {
  const { ctx, useEditor } = genEditorContext<TEntity>();
  const GrandWrapper = function EditorGrandWrapper(props: {
    children: React.ReactNode;
  }) {
    return (
      <Wrapper<TContainer, TEntity, TNewEntity>
        config={config}
        ctx={ctx}
        children={props.children}
      />
    );
  };

  return { useEditor, EditorProvider: GrandWrapper };
}
